module.exports = "/_next/static/images/uv-rotate-bg-645b81925eaa0686bc718158f514a393.png";